module.exports = __webpack_public_path__ + "img/sport.94d44167.png";